import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Mark } from '@/components/ui/Mark';
import styles from './SiteHeader.module.css';

export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  // The journey is a focus environment; a nav bar full of exits works against
  // that, so it drops back to just the mark while she is answering.
  const minimal = pathname.includes('/questions');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <Link to="/" className={styles.brand}>
        <Mark size={26} />
        <span className={styles.brandText}>Are We Compatible?</span>
      </Link>

      {minimal ? null : (
        <nav className={styles.nav} aria-label="Main">
          <NavLink to="/privacy" className={styles.navLink}>
            Privacy
          </NavLink>
        </nav>
      )}
    </header>
  );
}
